import { render, staticRenderFns } from "./IntelligentCodeDetail.vue?vue&type=template&id=b3fd004e&scoped=true&"
import script from "./IntelligentCodeDetail.vue?vue&type=script&lang=js&"
export * from "./IntelligentCodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentCodeDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./IntelligentCodeDetail.vue?vue&type=style&index=1&id=b3fd004e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fd004e",
  null
  
)

component.options.__file = "IntelligentCodeDetail.vue"
export default component.exports